import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ErrorManagerService extends Service {
	@tracked errors = [];
	_nextId = 1;

	@action
	addError(message, { clearable = true, type = 'general' } = {}) {
		const id = this._nextId++;
		this.errors = [...this.errors, { id, message, clearable, type }];
		setTimeout(() => {
			const banner = document.getElementById('error-banner-container');
			if (banner) {
				banner.scrollIntoView({ behavior: 'instant', block: 'start' });
			}
		}, 0);
		return id;
	}

	@action
	removeError(id) {
		this.errors = this.errors.filter(e => e.id !== id);
	}

	@action
	clearAllClearable() {
		this.errors = this.errors.filter(e => !e.clearable);
	}
}
